//Generated File 
export default class PrintAuthority{
	static readonly Disabled = `Disabled`;
	static readonly MoreThanOne = `MoreThanOne`;
	static readonly One = `One`;
}
